import { FC, HTMLProps, SVGProps } from 'react';

import { JabraIcon } from './JabraIcon/JabraIcon';

export interface InteractionHintProps extends HTMLProps<HTMLDivElement> {
  icon?: FC<SVGProps<SVGElement>>;
  text?: string;
}

export const InteractionHint: FC<InteractionHintProps> = ({ icon, text, ...divProps }) => {
  return (
    <div className="flex items-center rounded-md bg-gray-50 px-6 py-4 text-black" {...divProps}>
      {icon ? <JabraIcon className="mr-2 size-[3.125rem]" Icon={icon} /> : null}
      <div>{text}</div>
    </div>
  );
};
